import { View } from 'components/View'
import React from 'react'
import WorkoutNameText from 'pages/Workout/components/Workout/components/NameText/index.js'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import canEditByIdWorkoutSelector from 'modules/workout/redux/selectors/can-edit-by-id/index.js'
import WorkoutEditName from 'pages/Workout/components/Workout/components/EditName/index.js'

/**
 * @param id
 * @param onClickName
 * @param isAboutVisible
 * @returns {JSX.Element}
 * @constructor
 */
export default function WorkoutName ({
  id,
  isAboutVisible,
  onClickName
}) {
  const canEdit = useSelector(canEditByIdWorkoutSelector(id))
  let element

  const propsToPass = {
    isAboutVisible,
    id,
    onClickName
  }

  if (canEdit) {
    element = <WorkoutEditName {...propsToPass} />
  } else {
    element = <WorkoutNameText {...propsToPass} />
  }

  return (
    <View>
      {element}
    </View>
  )
}
